<div class="app-wrapper">
  @if (loginDisplay) {
  <app-header class="header"></app-header>
  }

  <div class="content">
    <router-outlet></router-outlet>
  </div>
  @if(loading){
  <div class="backdrop">
    <ix-spinner class="spinner"></ix-spinner>
  </div>
  }
</div>

@if (appStarter) {
<div class="auth-loader">
  <img class="logo" src="/assets/images/brand-logo.svg" alt="Logo Siemens AKG" />
  <span class="app-name">Virtual Point Creator</span>
  <mat-progress-bar class="progress-bar" mode="indeterminate"></mat-progress-bar>
</div>
}
